<template lang="pug">
section(v-bind:class="sectionClass")
	.section-content
		.columns.column-text-side
			.column.is-narrow
				img.who.luciano(src="/img/luciano2.jpg" alt="")
			.column
				.title.is-spaced
					| {{ $t('home.title3_l1') }}&nbsp;
					br
					| {{ $t('home.title3_l2') }}
				p.subtitle.no-margin-bottom(style="text-align:justify;")
					| {{ $t('home.content3_l1') }}
				.with-quotes
					img.quote1(src="/img/quote1.png")
					img.quote2(src="/img/quote2.png")
					p
						| {{ $t('home.quote3_l1') + ' ' }}
						| {{ $t('home.quote3_l2') + ' ' }}
						| {{ $t('home.quote3_l3') }}

</template>

<script>
export default {
	name : 'SectionLuciano',
	props: {
		num: Number
	},
	computed: {
		sectionClass() {
			return {
				'section'                : true,
				'border-bottom-section'  : true,
				'section-background-grey': this.num % 2 === 0
			}
		}
	}
}
</script>
